<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/N3kB1M/tc-custom/9781328637901.jpg?1730587720165" alt="This image is the cover for the book Glory Days"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Glory Days
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A rollicking guided tour of one extraordinary summer, when some of the most pivotal and freakishly coincidental stories all collided and changed the way we think about modern sports</b><br/><br/> The summer of 1984 was a watershed moment in the birth of modern sports when the nation watched Michael Jordan grow from college basketball player to professional athlete and star. That summer also saw ESPN’s rise to media dominance as the country’s premier sports network and the first modern, commercialized, profitable Olympics. Magic Johnson and Larry Bird’s rivalry raged, Martina Navratilova and John McEnroe reigned in tennis, and Hulk Hogan and Vince McMahon made pro wrestling a business, while Donald Trump pierced the national consciousness as a pro football team owner. It was an awakening in the sports world, a moment when sports began to morph into the market-savvy, sensationalized, moneyed, controversial, and wildly popular arena we know today.<br/>  <br/> In the tradition of Bill Bryson’s <i>One Summer: America, 1927,</i> L. Jon Wertheim captures these 90 seminal days against the backdrop of the nostalgia-soaked 1980s, to show that this was the year we collectively traded in our ratty Converses for a pair of sleek, heavily branded, ingeniously marketed Nikes. This was the year that sports went big-time.  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        L. Jon Wertheim
      </h2>
      
      <p class="authorDescription body article"><P>L. Jon Wertheim is the executive editor of <I>Sports Illustrated</I>. He is the author of seven highly praised books, including the <I>New York Times</I> bestseller <I>Scorecasting</I>. He is a regular contributor to CNN and National Public Radio and is a commentator for the Tennis Channel.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66adffa0